import { Timestamp } from 'firebase/firestore'

export const dateToFirestoredate = (date: string) => Timestamp.fromDate(new Date(date))
